Object.defineProperty(exports,"__esModule",{value:true});var ImageResizeMode={center:'center',contain:'contain',cover:'cover',none:'none',repeat:'repeat',stretch:'stretch'};exports.default=ImageResizeMode;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-native-web/dist/components/Image/ImageResizeMode.js
 ** module id = 342
 ** module chunks = 0
 **/